import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface FadeInProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
}
export function FadeIn({
  children,
  className = '',
  delay = 0,
  direction = 'up'
}: FadeInProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const getInitial = () => {
    switch (direction) {
      case 'up':
        return {
          opacity: 0,
          y: 40
        };
      case 'down':
        return {
          opacity: 0,
          y: -40
        };
      case 'left':
        return {
          opacity: 0,
          x: 40
        };
      case 'right':
        return {
          opacity: 0,
          x: -40
        };
      default:
        return {
          opacity: 0
        };
    }
  };
  return <motion.div ref={ref} initial={getInitial()} animate={isInView ? {
    opacity: 1,
    x: 0,
    y: 0
  } : getInitial()} transition={{
    duration: 0.8,
    delay: delay,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={className} data-id="element-185">
      {children}
    </motion.div>;
}